/**
 * Order formatting utilities for AI consumption
 */
// Fulfillment status mapping for orders
export const FULFILLMENT_STATUS_MAP = {
    UNFULFILLED: 'Not yet shipped',
    PARTIAL: 'Partially shipped',
    FULFILLED: 'Shipped',
    IN_TRANSIT: 'In transit',
    OUT_FOR_DELIVERY: 'Out for delivery',
    DELIVERED: 'Delivered',
};
/**
 * Format orders for AI consumption
 * Transforms raw Shopify order data into a clean, LLM-friendly format
 */
export const formatOrdersForAI = (orders) => orders.map((order) => {
    const items = order.lineItems?.edges?.map((edge) => {
        const { node } = edge;
        return `${node.quantity}x ${node.name} ($${node.variant?.price || 'N/A'})`;
    }) || [];
    const tracking = order.fulfillments?.[0]?.trackingInfo?.[0];
    const trackingInfo = tracking ? {
        number: tracking.number,
        url: tracking.url,
        company: tracking.company,
    } : null;
    return {
        number: order.orderNumber || order.name?.replace('#', ''),
        name: order.name,
        date: new Date(order.processedAt).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        }),
        payment: order.displayFinancialStatus,
        fulfillment: FULFILLMENT_STATUS_MAP[order.displayFulfillmentStatus]
            || order.displayFulfillmentStatus,
        total: `$${order.currentTotalPriceSet?.shopMoney?.amount || 'N/A'} ${order.currentTotalPriceSet?.shopMoney?.currencyCode || 'USD'}`,
        items,
        tracking: trackingInfo,
        estimatedDelivery: order.fulfillments?.[0]?.estimatedDeliveryAt
            ? new Date(order.fulfillments[0].estimatedDeliveryAt).toLocaleDateString('en-US')
            : null,
    };
});
//# sourceMappingURL=formatOrders.js.map